import axios from 'axios';
import Vue from 'vue'

export default {
    getInvoices (page, pageSize, customerId,status,start,end, type) {
        return axios.get('/api/invoices/list', { params: {page: page, pageSize: pageSize, customerId:customerId,status:status,start:start,end:end, docType:type} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getConsigneList (page, pageSize, customerId) {
        return axios.get('/api/invoices/consigne-list', { params: { page: page, pageSize: pageSize, customerId: customerId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBeingValidationInvoices (page, pageSize, customerId, dbAgencyId) {
        return axios.get('/api/invoices/being-validation/list', { params: {page: page, pageSize: pageSize, customerId: customerId, dbAgencyId: dbAgencyId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getRelatedReglement (page, pageSize,invoiceId) {
        return axios.get('/api/invoices/related/reglement/list', { params: { page: page, pageSize: pageSize, invoiceId:invoiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getRelatedBL (page, pageSize,invoiceId) {
        return axios.get('/api/invoices/related/BL/list', { params: { page: page, pageSize: pageSize, invoiceId:invoiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getRelatedBR (page, pageSize,invoiceId) {
        return axios.get('/api/invoices/related/BR/list', { params: { page: page, pageSize: pageSize,invoiceId:invoiceId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getBLs (page, pageSize, customerId,status,start,end,type, dbAgencyId) {
        return axios.get('/api/invoices/bl-list', { params: {page: page, pageSize: pageSize, customerId:customerId,status:status,start:start,end:end,type:type , docType: "bl", dbAgencyId:dbAgencyId} })
        .then(response => {
            if (response && response.data) {
              response.data.page = page;
              response.data.pageSize = pageSize;
              response.data.total = response.data.list.length
              return response.data
            }
          })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadBL(blId, type, invoiceType) {
      return new Promise((resolve, reject) => {
        axios({
          url: '/api/invoices/download/' + type + '/' + blId  + (invoiceType == null ? '' :  '/' + invoiceType),
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          const contentType = response.headers['content-type'];
          const filename = response.headers['filename'] || 'document';

          if (contentType && contentType.includes('text/html')) {
            // HTML: open in new tab
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            window.URL.revokeObjectURL(url);
            resolve();
          } else {
            // Binary file (e.g., Excel, PDF): download
            const blob = new Blob([response.data], { type: contentType });
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            resolve();
          }
        }).catch(error => {
          Vue.prototype.$snotify.error('Le téléchargement du document a échoué');
          reject(error);
        });
      });
    },

      downloadBLByDocNumber(blNumber , company, type, customerId) {
        return new Promise((resolve, reject) => {
          axios({
            url: '/api/invoices/download-bl', 
            params: {
              blNumber: blNumber, 
              type: type,
              company: company,
              customerId:customerId,
            },
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            const blob = new Blob(
              [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }
            );
            const aEle = document.createElement('a');
            const href = window.URL.createObjectURL(blob);
            aEle.href = href;
            aEle.download = response.headers["filename"];
            document.body.appendChild(aEle);
            aEle.click();
            document.body.removeChild(aEle);
            window.URL.revokeObjectURL(href);
            resolve(); // Resolve the promise indicating successful download
          }).catch(error => {
            Vue.prototype.$snotify.error('Le téléchargement du document a échoué');
            reject(error); // Reject the promise indicating download failure
          });
        });
      },
      


    getAvoirs (page, pageSize, customerId,status,start,end,type,dbAgencyId) {
        return axios.get('/api/invoices/bl-list', { params: {page: page, pageSize: pageSize, customerId:customerId,status:status,start:start,end:end, type:type, docType : "retour", dbAgencyId:dbAgencyId} })
        .then(response => {
          if (response && response.data) {
            response.data.page = page;
            response.data.pageSize = pageSize;
            response.data.total = response.data.list.length
            return response.data
          }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesCount(status){
        return axios.get('/api/invoices/count/',{ params: { status:status} })
        .then(response => {
            if (response && response.data)  return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportInvoicesListExcel(page, pageSize,customerId,status,start,end, type){
        return axios({
            url:'/api/invoices/export/excel/list',
            params: { page: page, pageSize: pageSize,customerId:customerId, status:status, start:start,end:end, docType:type},
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const blob = new Blob(
                [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                const aEle = document.createElement('a');     // Create a label
                const href = window.URL.createObjectURL(blob);       // Create downloaded link
                aEle.href = href;
                aEle.download = response.headers["filename"];  // File name after download
                document.body.appendChild(aEle);
                aEle.click();     // Click to download
                document.body.removeChild(aEle); // Download complete remove element
                window.URL.revokeObjectURL(href) // Release blob object
                
          });
    },

    export(page, pageSize,customerId,status,start,end, type){
        return axios({
            url:'/api/invoices/export/excel/check',
            params: { page: page, pageSize: pageSize,customerId:customerId, status:status, start:start,end:end, docType:type},
            method: 'GET',
          }).then(() => {
            return this.exportInvoicesListExcel(page, pageSize,customerId,status,start,end,type);
                
          }).catch(error => {Vue.prototype.$snotify.error(error);});
    },


    getBodyMail(mailId) {
      return axios.get('/api/invoices/mail/body', { params: {mailId: mailId} })
      .then(response => {
          if (response && response.data) return response.data
      })
      .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getStatusMailInvoices (page, pageSize, customerId,start,end,companyType, mailStatus) {
        return axios.get('/api/invoices/status/list',{ params: {page: page, pageSize: pageSize, customerId:customerId,start:start,end:end, companyType:companyType, mailStatus:mailStatus} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    
    resendMailInvoices (page, pageSize, customerId,start,end, invoiceTypeList, companyType, mailStatus) {
        return axios.post('/api/invoices/resend/mail', invoiceTypeList, { params: {page: page, pageSize: pageSize, customerId:customerId,start:start,end:end, companyType:companyType, mailStatus:mailStatus} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    resendInvoice(invoiceId , invoicesNumber, page, pageSize, customerId,start,end, selectedList, companyType, mailStatus){
        return axios.post('/api/invoices/resend-mail',selectedList, { params: {invoiceId: invoiceId, page: page, pageSize: pageSize, customerId:customerId,start:start,end:end, companyType:companyType, mailStatus:mailStatus} })
        .then(response => {
            if (response && response.data) {
              Vue.prototype.$snotify.success("L’e-mail de la facture " +invoicesNumber+" envoyé avec succès.");
              return response.data
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    validateAllInvoices (date, dbAgencyId) {
        return axios.get('/api/invoices/validate-date', { params: { date: date, dbAgencyId: dbAgencyId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findLastValidationDate () {
        return axios.get('/api/invoices/last-validation/date')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    

}